import axios from 'axios'
import router from '@/router'
import { i18n } from '@/i18n'

const state = {
    idToken: localStorage.getItem('token') || null,
    userId: null,
    user: null,
    types: null
}

const mutations = {
    'AUTH_USER'(state, userData) {
        state.idToken = userData.token
        // state.userId = userData.userId
    },
    'STORE_USER'(state, user) {
        state.user = user
    },
    'CLEAR_AUTH_DATA'(state) {
        state.idToken = null
        state.userId = null
    },
    'GET_USER_DATA'(state, user) {
        state.user = {
            user: user.user,
            roles: user.roles
        }
        var result = Object.keys(user.types).map(function(key) {
            return {name: user.types[key], id: Number(key)};
        });

        state.types = result
    }
}

const actions = {
    //Login functie
    login({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'login', {
                email: authData.email,
                password: authData.password
            }).then((res) => {
                const expiresAt = res.data.success.expires_at
                const accessToken = res.data.success.token

                localStorage.setItem('token', accessToken)
                localStorage.setItem('expirationDate', expiresAt)
                commit('AUTH_USER', {
                    token: accessToken
                })
                dispatch('userData')
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
    //Default data ophalen na inlog
    userData: async ({commit, state}) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.idToken
        let app = this
        return axios.get(process.env.VUE_APP_API_URL + 'data')
            .then((res) => {
                commit('GET_USER_DATA', res.data)
                //Taal instellen
                i18n.locale = res.data.user.language
                return true
            })
            //Opnieuw inloggen bij verkeerde token, bv aanmaken in localstorage
            .catch(error => {
                localStorage.removeItem('expirationDate')
                localStorage.removeItem('token')
                localStorage.removeItem('userId')
                state.idToken = null
                state.userId = null
                return false
            })
    },
    //Logout functie
    destroyToken(context) {
        if (context.getters.isAuthenticated) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API_URL + 'logout')
                    .then((res) => {
                        localStorage.removeItem('expirationDate')
                        localStorage.removeItem('token')
                        localStorage.removeItem('userId')
                        context.commit('CLEAR_AUTH_DATA')
                        router.push({name: 'landingpage'})
                        resolve(res)
                    })
                    .catch(error => {
                        localStorage.removeItem('expirationDate')
                        localStorage.removeItem('token')
                        localStorage.removeItem('userId')
                        reject(error)
                    })
            })
        }
    },
    //Bij 401 (unauthorized), token enzo leegmaken
    interceptToken(context) {
        localStorage.removeItem('expirationDate')
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        context.commit('CLEAR_AUTH_DATA')
        router.push({name: 'login'})
    },
    uncheckAllCountries(context) {
        context.commit('UNCHECK_ALL_COUNTRIES')
    },
    uncheckOverview(context) {
        context.commit('UNCHECK_OVERVIEW')
    },
    checkOverview(context) {
        context.commit('CHECK_OVERVIEW')
    },
    //Password email link request
    PASSWORD_FORGOT({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'password/email', {
                email: authData.email
            }).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
    //New password set
    PASSWORD_RESET({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'password/reset', {
                email: payload.email,
                token: payload.token,
                password: payload.password,
                password_confirmation: payload.password_confirmation
            }).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
}

const getters = {
    USER(state) {
        return state.user
    },
    isAuthenticated(state) {
        return state.idToken !== null
    },
    ROLES(state) {
        if(state.user.user.roles[0]){
            return state.user.user.roles[0].name
        }else{
            return null
        }
    },
    IS_USER(state){
        if(state.user.user.roles[0].name == 'user'){
            return true
        }else{
            return false
        }
    },
    ALLROLES(state){
        return state.user.roles
    },
    ALLTYPES(state){
        return state.types
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
